import { types, actions } from './requests'
export const GETWORK_TYPES = {
    ...types('GETWORK'),
}
export const GETWORK_ACTIONS = {
    ...actions('GETWORK'),
}
